// Services
import {
  fetchCheckoutOrderDataService,
  saveRedirectDataService,
} from '../services/checkout.service';
// Types
import { AppCheckoutOrderContextType } from 'contexts/types/app.contexts.type';
// Utils
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';

const fetchCheckoutOrderDataResolver = async (): Promise<
  [AppCheckoutOrderContextType] | [null, true]
> => {
  const [response] = await fetchCheckoutOrderDataService();

  return response?.merchantOrderId ? [response] : [null, true];
};

const saveRedirectDataResolver = async (device: string): Promise<[boolean] | [null, boolean]> => {
  const [, { status }] = await saveRedirectDataService(device);

  return requestHasSuccessStatus(status) ? [true] : [null, true];
};

export { fetchCheckoutOrderDataResolver, saveRedirectDataResolver };
